import type { RouteRecordRaw } from 'vue-router'

export const workerRoutes: RouteRecordRaw[] = [
    {
        path: '/workers',
        name: 'Workers',
        component: () => import('@/views/workers/WorkersView.vue'),
        meta: { requiresAuth: true, allowedRoles: ['ADMIN', 'SUPERVISOR'] },
    },
    {
        path: '/workers/:id',
        name: 'WorkerDetail',
        component: () => import('@/views/workers/WorkerDetail.vue'),
        meta: { requiresAuth: true, allowedRoles: ['ADMIN', 'SUPERVISOR'] },
    },
    {
        path: '/workers/activities',
        name: 'WorkerActivities',
        component: () => import('@/views/workers/WorkerActivitiesView.vue'),
        meta: { requiresAuth: true, allowedRoles: ['ADMIN', 'SUPERVISOR'] },
    },
    {
        path: '/workers/reports',
        name: 'WorkerReports',
        component: () => import('@/views/workers/WorkerReportsView.vue'),
        meta: { requiresAuth: true, allowedRoles: ['ADMIN', 'SUPERVISOR'] },
    },
    {
        path: '/workers/leaderboard',
        name: 'WorkerLeaderboard',
        component: () => import('@/views/workers/WorkerLeaderboardView.vue'),
        meta: { requiresAuth: true, allowedRoles: ['ADMIN', 'SUPERVISOR'] },
    },
]


